import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M16.5 19h-15c-.3 0-.5-.2-.5-.5v-6.7l7.8 3.7c.1 0 .1.1.2.1s.1 0 .2-.1l7.8-3.7v6.7c0 .3-.2.5-.5.5zm0-11H12c-.3 0-.5.2-.5.5s.2.5.5.5h4.5c.3 0 .5.2.5.5v1.2l-8 3.8-8-3.8V9.5c0-.3.2-.5.5-.5H6c.3 0 .5-.2.5-.5S6.3 8 6 8H1.5C.7 8 0 8.7 0 9.5v9c0 .8.7 1.5 1.5 1.5h15c.8 0 1.5-.7 1.5-1.5v-9c0-.8-.7-1.5-1.5-1.5z',
    'M18.4 3.2l-3-3c-.2-.2-.5-.2-.7 0s-.2.5 0 .7L16.8 3H13C9.7 3 8.5 5.4 8.5 7.5V10c0 .3.2.5.5.5s.5-.2.5-.5V7.5c0-.8.3-3.5 3.5-3.5h3.8l-2.1 2.2c-.2.2-.2.5 0 .7 0 0 .2.1.3.1s.3-.1.4-.2l3-3c.1-.1.1-.5 0-.6z',
  ],
  height: 20,
  width: 20,
});
